import styles from "./ChartSkeleton.module.css";

type SkeletonVariant = "chart" | "kpi" | "table" | "scatter";

interface ChartSkeletonProps {
  variant?: SkeletonVariant;
}

const BAR_HEIGHTS = [45, 70, 55, 85, 60, 40, 75];

function ChartBars() {
  return (
    <div className={styles.chartSkeleton} role="status" aria-label="Loading chart">
      <div className={styles.chartBars}>
        {BAR_HEIGHTS.map((h, i) => (
          <div key={i} className={styles.chartBar} style={{ height: `${h}%` }} />
        ))}
      </div>
      <div className={styles.chartAxis} />
    </div>
  );
}

function KpiGrid() {
  return (
    <div className={styles.kpiSkeleton} role="status" aria-label="Loading overview">
      <div className={styles.kpiGrid}>
        {Array.from({ length: 6 }, (_, i) => (
          <div key={i} className={styles.kpiCard} />
        ))}
      </div>
      <div className={styles.kpiHealth} />
    </div>
  );
}

function TableRows() {
  return (
    <div className={styles.tableSkeleton} role="status" aria-label="Loading table">
      <div className={styles.tableHeader} />
      {Array.from({ length: 5 }, (_, i) => (
        <div key={i} className={styles.tableRow} />
      ))}
    </div>
  );
}

function ScatterPlot() {
  return (
    <div className={styles.scatterSkeleton} role="status" aria-label="Loading scatter plot">
      <div className={styles.scatterArea} />
    </div>
  );
}

export function ChartSkeleton({ variant = "chart" }: ChartSkeletonProps) {
  switch (variant) {
    case "kpi":
      return <KpiGrid />;
    case "table":
      return <TableRows />;
    case "scatter":
      return <ScatterPlot />;
    case "chart":
    default:
      return <ChartBars />;
  }
}
